<template>
  <div>
    <div
      v-for="(item, index) in itemsFiltered"
      :key="index"
      class="bg-light-gray mt-4 p-3 rounded"
    >
      <div class="row">
        <div class="text-right col-12" style="height: 0;">
          <span class="rounded-circle shadow-sm text-center history-icon">
            <i class="fal fa-retweet text-white"></i>
          </span>
        </div>
        <div class="col-lg-12 mt-3">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Nombre de Actividad:
          </div>
          <div class="color-black font-16 ">
            {{ item.name }}
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Fecha de Actividad:
          </div>
          <div class="color-black font-16 ">
            {{ formatDate(item.date) }}
          </div>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-12 mt-3">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Tipo de Actividad:
          </div>
          <div class="color-black font-16 ">
            {{ item.activityType }}
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Hora Desde:
          </div>
          <div class="color-black font-16 ">
            {{ getTimeFromDate(item.start) }}
          </div>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-12 mt-3">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Hora Hasta:
          </div>
          <div class="color-black font-16 ">
            {{ getTimeFromDate(item.end) }}
          </div>
        </div>
        <div class="col-lg-12 mt-3">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Lugar:
          </div>
          <div class="color-black font-16 ">
            {{ item.caat }}
          </div>
        </div>
        <div class="col-lg-12 mt-3">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Estatus:
          </div>
          <div class="color-black font-16 ">
            <span class="d-flex align-items-center">
              <div
                class="status-indicator"
                :style="{ backgroundColor: item.color }"
              >
                &nbsp;
              </div>
              <span class="text font-weight-bold">{{ item.status }}</span>
            </span>
          </div>
        </div>
        <div class="col-lg-12 mt-3">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Participantes:
          </div>
          <div class="color-black font-16 ">
            {{ getParticipant(item) }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.currentRowCount < this.items.length" class="row mt-4">
      <div class="col text-center">
        <action-button
          variant="outline-success custom-view-more actionButton"
          i="fas fa-chevron-down"
          @click="loadMore"
        >
          {{ viewMoreLabels }}
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import moment from 'moment';
import CustomResultNotFound from 'custom-result-not-found';

export default {
  name: 'ActivityHistory',
  components: {
    ActionButton,
    CustomResultNotFound,
  },
  data: () => ({
    maxRows: 5,
    itemsFiltered: [],
    currentRowCount: 0,
  }),
  watch: {
    items: {
      immediate: true,
      handler: function(newValue) {
        this.loadMore();
      },
    },
  },
  props: {
    items: { type: Array, default: () => [] },
    viewMoreLabels: { type: String, default: 'Ver Más' },
    hasCloseButton: { type: Boolean, default: false },
  },
  computed: {
    getParticipant() {
      return (item) =>
        item.participants.length > 0
          ? item.participants.map((a) => a.fullName ?? a.userName).join(', ')
          : '-';
    },
    getCompany() {
      return (item) =>
        item.participants.length > 0
          ? item.participants.map((a) => a.companyName).join(', ')
          : '-';
    },
  },
  mounted() {},
  methods: {
    loadMore() {
      this.currentRowCount += this.maxRows;
      this.itemsFiltered = this.items.slice(0, this.currentRowCount);
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    getTimeFromDate(value) {
      return moment(value).format('h:mm A');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.title {
  font-size: 16px;
  font-weight: bold;
  color: map-get($colors, 'gray-12');
}
.event-date {
  font-weight: bold;
  font-size: 15px;
  color: #11291b;
  opacity: 1;
}
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.text {
  font-size: 16px;
  color: $black_2;
}
.text-small {
  font-size: 14px;
}

.actionButton {
  border-radius: 19px;
}

.radius {
  padding: 7px 0 0 0 !important;
  width: 30px !important;
  height: 30px !important;
}
.history-icon {
  width: 34px;
  padding: 4px;
  background: rgb(181, 195, 188);
  top: 10px;
  position: relative;
}
</style>
